export default [
  // 教师后台
  {
    path: '/teach',
    name: 'Teach',
    component: () => import('@/views/pages/teach/index.vue'),
    redirect: '/teach/course',
    children: [
      {
        path: 'course',
        name: 'course',
        meta: { title: "课程管理" },
        component: () => import('@/views/pages/teach/course/index.vue')
      },
      {
        path: 'class',
        name: 'class',
        meta: { title: "班级管理" },
        component: () => import('@/views/pages/teach/class/index.vue')
      },
      {
        path: 'contest',
        name: 'contest',
        meta: { title: "比赛管理" },
        component: () => import('@/views/pages/teach/contest/index.vue')
      },
      {
        path: 'training',
        name: 'training',
        meta: { title: "学习中心" },
        component: () => import('@/views/pages/teach/training/index.vue')
      }
    ]
  }
]
